interface UseHeaderProps {
  pathname: string
}

interface UseHeader {
  headerType: string
  showSiteHeaderButton: boolean
}

const primaryPages = [
  '/',
  '/booking-widget',
  '/pack',
  '/what-can-i-ship',
  '/partnership-benefits',
  '/guarantee',
  '/how-it-works',
  '/track-orders',
  '/order-tracking',
  '/affiliate',
  '/about',
  '/faq',
  '/contact',
  '/careers',
  '/reviews',
  '/claims',
  '/gift-cards',
  '/how-to-ship-golf-clubs',
  '/sitemap',
  '/track',
  '/privacy',
  '/partner-agreement-terms',
  '/terms',
]
const siteHeaderButtonPages = ['/booking-widget', '/']

const useHeader = ({ pathname }: UseHeaderProps): UseHeader => {
  // update to handle pages with path variables, i.e /path/:id
  const parts = pathname.split('/')
  const pathPrefix = '/' + parts[1]
  const headerType = primaryPages.includes(pathPrefix) ? 'primary' : 'secondary'
  const showSiteHeaderButton = !siteHeaderButtonPages.includes(pathPrefix)

  return { headerType, showSiteHeaderButton }
}

export default useHeader
